import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-horizontal",
  "use": "icon-more-horizontal-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" role=\"img\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" class=\"css-1eamic5 ex0cdmw0\" id=\"icon-more-horizontal\"><title>MoreHorizontal icon</title><path d=\"M16 24a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM27.5 24a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM35.5 27.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol